//  Copyright (c) 2020 First Foundry Inc. All rights reserved.

export const PATH = 'salesByBrand'
export const SET_START_DATE = `${PATH}/SET_START_DATE`
export const SET_END_DATE = `${PATH}/SET_END_DATE`
export const OPEN_SALES_BY_BRAND_REPORT = `${PATH}/OPEN_SALES_BY_BRAND_REPORT`
